/**
 * Escape user-supplied strings for safe interpolation into HTML
 * generated for PDF/print windows. Prevents XSS via injected markup.
 */
export function escapeHtml(value: unknown): string {
  if (value === null || value === undefined) return "";
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/** Alias used inside template literals for terseness: ${e(name)} */
export const e = escapeHtml;